import userService from '@/api/user'

export default {
  namespaced: true,
  actions: {
    searchUser: function (_, {query}) {
      return new Promise((resolve, reject) => {
        if (query.length === 1 || !query || query.match('(  )')) {
          resolve([])
        } else {
          userService.searchUsers(query).then((response) => {
            resolve(response.data)
          }).catch(() => {
            reject([])
          })
        }
      })
    }
  }
}
